import {TransactionsEntityFactory} from '../Entities/factory.js'
import {TransactionRequestsFactory} from '../Requests/factory.js'
import {TransactionsValueObjectsFactory} from '../ValueObjects/factory.js'
import {FromApiResponseToLoanCalculationsTransactionsValueObjectMapper} from './FromApiResponseToLoanCalculationsTransactionsValueObjectMapper.js'
import {FromRawDataToLoanCalculationEntityObjectTransactionsMapper} from './FromRawDataToLoanCalculationEntityObjectTransactionsMapper.js'
import {FromUseCaseParamsToGetLoanCalculationsTransactionsRequestMapper} from './FromUseCaseParamsToGetLoanCalculationsTransactionsRequestMapper.js'

export class TransactionsMappersFactory {
  static fromUseCaseParamsToGetLoanCalculationsTransactionsRequestMapper = () =>
    new FromUseCaseParamsToGetLoanCalculationsTransactionsRequestMapper({
      getLoanCalculationsTransactionsRequestFactory: TransactionRequestsFactory.getLoanCalculationsTransactionsRequest
    })

  static fromApiResponseToLoanCalculationsTransactionsValueObjectMapper = () =>
    new FromApiResponseToLoanCalculationsTransactionsValueObjectMapper({
      loanCalculationsTransactionsValueObjectFactory:
        TransactionsValueObjectsFactory.loanCalculationsTransactionsValueObject
    })

  static fromRawDataToLoanCalculationEntityObjectTransactionsMapper = ({config}) =>
    new FromRawDataToLoanCalculationEntityObjectTransactionsMapper({
      config,
      loanCalculationsB2CTransactionsEntity: TransactionsEntityFactory.loanCalculationsB2CTransactionsEntity
    })
}
